import ArrayField from '../shared/components/array-field';
import ArrayFieldCocoon from '../shared/components/array-field-cocoon';
import ComponentManager from '../shared/component-manager';
import DatePicker from '../shared/components/date-picker';
import DropdownSelect from '../shared/components/dropdown-select';
import DynamicDropdown from '../shared/components/dynamic-dropdown';
import MenteeStatusDropdown from '../shared/components/mentee-status-dropdown';
import MaxSizeFileField from '../shared/components/max-size-file-field';
import PhoneField from '../shared/components/phone-field';
import OrganizationBillingCoordinatesForm from '../shared/components/organization-billing-coordinates-form';
import QuickSubmit from '../shared/components/quick-submit';
import TagField from '../shared/components/tag-field';

class FormComponentManager extends ComponentManager {
  initializeComponents() {
    ArrayField.initialize('.arrayField');
    ArrayFieldCocoon.initialize('.arrayField--cocoon');
    DatePicker.initialize('.datePicker');
    DropdownSelect.initialize('.dropdownSelect');
    DynamicDropdown.initialize('.dynamicDropdown');
    MenteeStatusDropdown.initialize('.menteeStatusSelect');
    MaxSizeFileField.initialize('.maxSizeFileField');
    PhoneField.initialize('.phoneField');
    OrganizationBillingCoordinatesForm.initialize('.organizationForm');
    QuickSubmit.initialize('.quickSubmit');
    TagField.initialize('.tagField');
  }
}

export const initialize = () => {
  jQuery(() => {
    new FormComponentManager([
      ArrayField,
      DatePicker,
      DropdownSelect,
      DynamicDropdown,
      MenteeStatusDropdown,
      PhoneField,
      OrganizationBillingCoordinatesForm,
      QuickSubmit,
      TagField,
    ]);
  });
};
